import React from 'react'
import styled from 'styled-components'
import GoodreadsGuide from '../goodreads-import/goodreads-guide'

type GoodreadsOnboardingProps = {
    onOnboardingFinished: () => void
}

const GoodreadsOnboarding: React.FunctionComponent<GoodreadsOnboardingProps> = ({ onOnboardingFinished }) => {
  return (
    <Container onImportStarted={onOnboardingFinished}/>
  )
}

const Container = styled(GoodreadsGuide)`
    padding: 0px;
`

export default GoodreadsOnboarding